import React        from 'react';
import {rand} from "../utils/helpers";

export default class BusinessControlTabs extends React.Component {

    constructor(props) {
        super(props);

		let lang = props.lang;

        this.state = {
			tabList: [lang.BusinessControlTab1, lang.BusinessControlTab2, lang.BusinessControlTab3, lang.BusinessControlTab4],
			flagSteps: 0,
			imgBigTop: 0,
			imgSmallTop: 0,
			imgTop: 0,
			topValue: 0
		};
    }


	setStepNav(val) {
		this.setState({
			flagSteps: val
		})
	};

	renderTabList = (item, index) => {
		let flagSteps = this.state.flagSteps;

		return (
			<li key={index} className={flagSteps === index ? 'active' : null} onClick={this.setStepNav.bind(this, index)}><span>{item}</span></li>
		)
	};

	componentDidMount() {
		window.addEventListener('scroll', this.handleScroll);
	}

	componentWillUnmount(){
		window.removeEventListener('scroll', this.handleScroll);
	}

	handleScroll = (event) => {
		event.preventDefault();
		event.stopPropagation();

		const tabsWrapper = document.getElementsByClassName('s-business-control');
		const tabsOffset = tabsWrapper[0].offsetTop;
		let scrollValue = window.pageYOffset;

		if (scrollValue > (tabsOffset - 865) && scrollValue < (tabsOffset + 865)) {
			let imgTop = this.state.imgTop;
			let topValue = this.state.topValue;

			if (window.pageYOffset > topValue) {
				this.setState({
					imgTop: imgTop + 0.25
				});
			}else {
				this.setState({
					imgTop: imgTop - 0.25
				});
			}

			this.setState({
				imgSmallTop: imgTop,
				topValue: scrollValue
			});
		}else {
			this.setState({
				imgSmallTop: 0,
				topValue: 0
			});
		}
	};

    render() {

        const { lang } = this.props;
		const { tabList, flagSteps, imgBigTop, imgSmallTop } = this.state;

        return (
			<div className="s-business-control">
				<div className="container">
					<ul className="list-unstyled clearfix business-control-tab-list">
						{tabList.map(this.renderTabList)}
					</ul>
				</div>
				<div className="business-control-cnt">

					{flagSteps === 0 ? (
						<div className="business-control-item">
							<div className="container">
								<div className="row">
									<div className="col-7">
										<h2 className="s-index__title t-left">{lang.BusinessMain1}</h2>
										<p className="business-control__desc">{lang.BusinessMain1Intro}</p>
										<div className="business-control-list">
											<div className="business-control-list-item">
												<div className="img">
													<div className="img-icon video_live"/>
												</div>
												<h3 className="title">{lang.BusinessMain1_1}</h3>
												<p className="desc">{lang.BusinessMain1_1Intro}</p>
											</div>

											<div className="business-control-list-item">
												<div className="img">
													<div className="img-icon settings"/>
												</div>
												<h3 className="title">{lang.BusinessMain1_2}</h3>
												<p className="desc">{lang.BusinessMain1_2Intro}</p>
											</div>

											<div className="business-control-list-item">
												<div className="img">
													<div className="img-icon computer_network"/>
												</div>
												<h3 className="title">{lang.BusinessMain1_3}</h3>
												<p className="desc">{lang.BusinessMain1_3Intro}</p>
											</div>
										</div>
									</div>
									<div className="col-5 business-control-img slide-0">
										<img src="/static/img/business/control/slides/img-1@2x.png" alt="" width="614" height="656" className="img-big"/>
										<div className="img-abs">
											<img src="/static/img/business/control/slides/img-1-2@2x.png" alt="" width="314" height="443" className="img-small" style={{top: imgSmallTop}}/>
										</div>
									</div>
								</div>
							</div>
						</div>
					) : null}

					{flagSteps === 1 ? (
						<div className="business-control-item">
							<div className="container">
								<div className="row">
									<div className="col-7">
										<h2 className="s-index__title t-left">{lang.BusinessMain2}</h2>
										<p className="business-control__desc">{lang.BusinessMain2Intro}</p>
										<div className="business-control-list">
											<div className="business-control-list-item">
												<div className="img">
													<div className="img-icon puzzle"/>
												</div>
												<h3 className="title">{lang.BusinessMain2_1}</h3>
												<p className="desc">{lang.BusinessMain2_1Intro}</p>
											</div>

											<div className="business-control-list-item">
												<div className="img">
													<div className="img-icon chat"/>
												</div>
												<h3 className="title">{lang.BusinessMain2_2}</h3>
												<p className="desc">{lang.BusinessMain2_2Intro}</p>
											</div>

											<div className="business-control-list-item">
												<div className="img">
													<div className="img-icon history"/>
												</div>
												<h3 className="title">{lang.BusinessMain2_3}</h3>
												<p className="desc">{lang.BusinessMain2_3Intro}</p>
											</div>
										</div>
									</div>
									<div className="col-5 business-control-img slide-1">
										<img src="/static/img/business/control/slides/img-2@2x.png" alt="" width="614" height="656" className="img-big"/>
										<div className="img-abs">
											<img src="/static/img/business/control/slides/img-2-2@2x.png" alt="" width="316" height="433" className="img-small" style={{top: imgSmallTop}}/>
										</div>
									</div>
								</div>
							</div>
						</div>
					) : null}

					{flagSteps === 2 ? (
						<div className="business-control-item">
							<div className="container">
								<div className="row">
									<div className="col-7">
										<h2 className="s-index__title t-left">{lang.BusinessMain3}</h2>
										<p className="business-control__desc">{lang.BusinessMain3Intro}</p>
										<div className="business-control-list">
											<div className="business-control-list-item">
												<div className="img">
													<div className="img-icon transp"/>
												</div>
												<h3 className="title">{lang.BusinessMain3_1}</h3>
												<p className="desc">{lang.BusinessMain3_1Intro}</p>
											</div>

											<div className="business-control-list-item">
												<div className="img">
													<div className="img-icon money_deal"/>
												</div>
												<h3 className="title">{lang.BusinessMain3_2}</h3>
												<p className="desc">{lang.BusinessMain3_2Intro}</p>
											</div>

											<div className="business-control-list-item">
												<div className="img">
													<div className="img-icon stat"/>
												</div>
												<h3 className="title">{lang.BusinessMain3_3}</h3>
												<p className="desc">{lang.BusinessMain3_3Intro}</p>
											</div>
										</div>
									</div>
									<div className="col-5 business-control-img slide-2">
										<img src="/static/img/business/control/slides/img-3@2x.png" alt="" width="614" height="656" className="img-big"/>
										<div className="img-abs">
											<img src="/static/img/business/control/slides/img-3-2@2x.png" alt="" width="335" height="459" className="img-small" style={{top: imgSmallTop}}/>
										</div>
									</div>
								</div>
							</div>
						</div>
					) : null}

					{flagSteps === 3 ? (
						<div className="business-control-item">
							<div className="container">
								<div className="row">
									<div className="col-7">
										<h2 className="s-index__title t-left">{lang.BusinessMain4} </h2>
										<p className="business-control__desc">{lang.BusinessMain4Intro}</p>
										<div className="business-control-list">
											<div className="business-control-list-item">
												<div className="img">
													<div className="img-icon telegram"/>
												</div>
												<h3 className="title">{lang.BusinessMain4_1}</h3>
												<p className="desc">{lang.BusinessMain4_1Intro}</p>
											</div>

											<div className="business-control-list-item">
												<div className="img">
													<div className="img-icon doc"/>
												</div>
												<h3 className="title">{lang.BusinessMain4_2}</h3>
												<p className="desc">{lang.BusinessMain4_2Intro}</p>
											</div>

											<div className="business-control-list-item">
												<div className="img">
													<div className="img-icon take_money"/>
												</div>
												<h3 className="title">{lang.BusinessMain4_3}</h3>
												<p className="desc">{lang.BusinessMain4_3Intro}</p>
											</div>
										</div>
									</div>
									<div className="col-5 business-control-img slide-3">
										<img src="/static/img/business/control/slides/img-4@2x.png" alt="" width="614" height="455" className="img-big"/>
										<div className="img-abs">
											<img src="/static/img/business/control/slides/img-4-2@2x.png" alt="" width="203" height="440" className="img-small" style={{top: imgSmallTop}}/>
										</div>
									</div>
								</div>
							</div>
						</div>
					) : null}

				</div>
			</div>
        );
    }
}
